export type ErudaUrlMatcher = string | RegExp | ((url: URL) => boolean)

/**
 * Añade aquí las URLs (o patrones) donde quieres que Eruda se active.
 *
 * Ejemplos:
 * - "/login" (path)
 * - "https://app.tudominio.com/admin"
 * - /localhost:\d+\/public-views/
 * - (url) => url.hostname === "staging.tudominio.com"
 */
export const ERUDA_ALLOWED_URLS: ErudaUrlMatcher[] = [
  'https://app.teaminglabs.com/player_view/d099cb8d-f889-4789-9b24-8a92155a99fc/f8a99bd5-3a08-4332-911a-742802542fad',
]

